"use client";
import { useEffect } from "react";
import Script from "next/script";
import { usePathname } from "next/navigation";
import { logError } from "@jetblue/dotcom-fe-logger";
import { functional } from "@jetblue/dotcom-trust-arc";
import type { DynamicYieldProperites } from ".";
import { init, setPageContext } from ".";
import { updateDynamicYieldConsent } from "./consent";
import {
  DEFAULT_DYNAMIC_YIELD_SECTION_ID,
  DYNAMIC_YIELD_CDN_ORIGIN,
} from "./constants";

export const DynamicYieldClient = ({
  sectionId,
  language,
}: DynamicYieldProperites) => {
  const pathname = usePathname();
  const effectiveSectionId = sectionId ?? DEFAULT_DYNAMIC_YIELD_SECTION_ID;

  useEffect(() => {
    if (!sectionId) {
      void logError({
        message: "DynamicYieldService initialized without sectionId defined",
      });
    }
  }, [sectionId]);

  useEffect(() => {
    const cancelInit = init(language);

    void (async () => {
      try {
        await functional();
        updateDynamicYieldConsent(true);
      } catch (error) {
        void logError({
          error,
          message: "Failed to resolve TrustArc consent decision for DY",
        });
      }
    })();

    return cancelInit;
  }, []);

  useEffect(() => {
    void setPageContext({
      currentUrl: globalThis.location.href,
      isHomePage: globalThis.location.pathname === "/",
      language,
    });
  }, [pathname]);

  return (
    <>
      <Script
        src={`${DYNAMIC_YIELD_CDN_ORIGIN}/api/${effectiveSectionId}/api_dynamic.js`}
      />
      <Script
        src={`${DYNAMIC_YIELD_CDN_ORIGIN}/api/${effectiveSectionId}/api_static.js`}
      />
    </>
  );
};
